/** Keep the conference controls accessible while giving the video more attention. */
export function installControlsAutoHide(screen: HTMLElement, controls: HTMLElement, keepVisible: () => boolean, delay = 5000, header?: HTMLElement | null, pinBottom: () => boolean = () => false): () => void {
  let timer: ReturnType<typeof setTimeout> | undefined;
  let pointerOverControls = false;
  const eligible = () => window.innerWidth >= 768 && Math.min(window.innerWidth, window.innerHeight) >= 600;
  const show = () => {
    controls.classList.remove('controls-auto-hidden');
    controls.removeAttribute('inert');
    header?.classList.remove('controls-auto-hidden');
    header?.removeAttribute('inert');
  };
  const schedule = () => {
    clearTimeout(timer);
    show();
    if (!eligible()) return;
    timer = setTimeout(() => {
      const focused = controls.contains(document.activeElement) || !!header?.contains(document.activeElement);
      const openMenu = Array.from(screen.querySelectorAll<HTMLElement>('.more-options-popover, .screen-share-active-popover, .picker-modal-overlay, .rename-modal-overlay, .view-mode-popover, .quick-device-menu')).some(el => getComputedStyle(el).display !== 'none' && getComputedStyle(el).visibility !== 'hidden');
      if (pointerOverControls || focused || openMenu) { schedule(); return; }
      if (!pinBottom()) { controls.classList.add('controls-auto-hidden'); controls.setAttribute('inert', ''); }
      if (!keepVisible()) {
        header?.classList.add('controls-auto-hidden');
        header?.setAttribute('inert', '');
      }
    }, delay);
  };
  const enter = () => { pointerOverControls = true; schedule(); };
  const leave = () => { pointerOverControls = false; schedule(); };
  screen.addEventListener('pointermove', schedule, { passive: true });
  screen.addEventListener('touchstart', schedule, { passive: true });
  controls.addEventListener('pointerenter', enter);
  controls.addEventListener('pointerleave', leave);
  header?.addEventListener('pointerenter', enter);
  header?.addEventListener('pointerleave', leave);
  document.addEventListener('keydown', schedule, true);
  document.addEventListener('focusin', schedule);
  window.addEventListener('resize', schedule);
  schedule();
  return () => {
    clearTimeout(timer);
    show();
    screen.removeEventListener('pointermove', schedule);
    screen.removeEventListener('touchstart', schedule);
    controls.removeEventListener('pointerenter', enter);
    controls.removeEventListener('pointerleave', leave);
    header?.removeEventListener('pointerenter', enter);
    header?.removeEventListener('pointerleave', leave);
    document.removeEventListener('keydown', schedule, true);
    document.removeEventListener('focusin', schedule);
    window.removeEventListener('resize', schedule);
  };
}
